import React, { useState } from "react";
import DialogWrapper from "./DialogWrapper";
import EmailInput from "../input/text/EmailInput";

const DialogImpersonate = ({ open, actionMethod }) => {

    const [email, setEmail] = useState(null);
    const cancel = () => { actionMethod("cancel", null) };

    return (
        <DialogWrapper
            open={open}
            onClose={cancel}
            title="Simular Utilizador"
            onCancel={cancel}
            onConfirm={() => actionMethod("submit", email)}
        >
            <EmailInput value={email ?? ""} onChange={(e) => setEmail(e.target.value)} type="email" />
        </DialogWrapper>
    );
}

export default DialogImpersonate;
